import { axiosRequest } from '@planbord/axios-request';
import { useQuery } from '@tanstack/vue-query';
import { SelectOption } from '@planbord/shared/models';

export const useListScheduleStateSelectOptions = () => {
  const baseUrl = '/api';

  return useQuery<SelectOption[]>({
    queryKey: ['listScheduleStateSelectOptions'],
    queryFn: () =>
      axiosRequest
        .get(`${baseUrl}/listScheduleStateSelectOptions`)
        .then((res) => res.data),
    // Use the cache for 60 minutes
    staleTime: 60 * 60000,
  });
};
